export enum ConstancyType {
    C20 = 20,
    C21 = 21, 
    C22 = 22, 
    C23 = 23,  
    C28 = 28,  
    C29 = 29,  
    C30 = 30, 
    C34 = 34,  
    C00 = 0
}